export const THEME = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;

export const THEME_TYPE = ['LIGHT', 'DARK'] as const;
